export class UserTypeConst {
  public static SHELL_USER = "shell";
  public static NON_SHELL_USER = "nonshell";
}
